// Шрифт Inter (оффлайн, self-hosted через @fontsource; включает latin + vietnamese).
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import './assets/design-system-variables.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import './assets/tooltip.css'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'

const app = createApp(App)

const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(FloatingVue, {
  themes: {
    tooltip: {
      delay: { show: 300, hide: 0 },
      instantMove: true,
      triggers: ['hover'],
    },
  },
})

// Mount app immediately - auth initialization happens in router
app.mount('#app')
